(() => {
  const initAnnouncement = (root) => {
    if (!root || root.dataset.dibbsAnnouncementReady === 'true') return;

    const messages = [...root.querySelectorAll('.db-announcement__message')];
    if (messages.length < 2) return;

    let current = 0;
    let timer;

    const show = (next) => {
      messages[current]?.classList.remove('is-active');
      messages[current]?.setAttribute('aria-hidden', 'true');
      current = next % messages.length;
      messages[current]?.classList.add('is-active');
      messages[current]?.setAttribute('aria-hidden', 'false');
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (document.hidden) return;
      const interval = Number(root.dataset.interval) || 4000;
      timer = window.setInterval(() => show(current + 1), interval);
    };

    root.dataset.dibbsAnnouncementReady = 'true';
    messages.forEach((message, index) => {
      message.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
    });

    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  };

  const initAll = () => {
    document.querySelectorAll('[data-dibbs-announcement]').forEach(initAnnouncement);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
